/************************************************************************
 *************************************************************************
 @Name :       	QapTcha - jQuery Plugin
 @Revison :    	4.1
 @Date : 		07/03/2012  - dd/mm/YYYY
 @Author:     	 ALPIXEL Agency - (www.myjqueryplugins.com - www.alpixel.fr) 
 @License :		 Open Source - MIT License : http://www.opensource.org/licenses/mit-license.php
 
 **************************************************************************
 *************************************************************************/
jQuery.QapTcha = {
    build: function (options)
    {
        var defaults = {
            txtLock: 'Zaključano : Otključaj povlačenjem strelice udesno...',
            txtUnlock: 'Otključano : Sad možeš da popuniš polja ...',
            disabledSubmit: true,
            autoRevert: true,
            servlet: '/srv/captcha',
            autoSubmit: false
        };

        if (this.length > 0)
            return jQuery(this).each(function (i) {
                /** Vars **/
                var
                        opts = $.extend(defaults, options),
                        $this = $(this),
                        form = $('form').has($this),
                        Clr = jQuery('<div>', {'class': 'clr'}),
                        bgSlider = jQuery('<div>', {'class': 'bgSlider'}),
                        Slider = jQuery('<div>', {'class': 'Slider'}),
                        TxtStatus = jQuery('<div>', {'class': ' TxtStatus dropError', text: opts.txtLock}),
                        inputQapTcha = jQuery('<input>', {name: generatePass(32), value: generatePass(7), type: 'hidden'});

                /** Disabled submit button **/
//			if(opts.disabledSubmit) {form.find('input[type="submit"]').attr('disabled','disabled'); }  //   nije htelo da locira formu, pa sam zakucao za ovaj id
                if (opts.disabledSubmit)
                    $('#recoveryBtn').attr('disabled', 'disabled');

                /** Construct DOM **/
                bgSlider.appendTo($this);
                Clr.insertAfter(bgSlider);
                inputQapTcha.appendTo($this);
                Slider.appendTo(bgSlider);
                TxtStatus.insertAfter(Slider);
                $this.show();
                console.log("usassa");

                // Make slider draggable 
                Slider.draggable({
                    revert: function () {
                        if (opts.autoRevert)
                        {
                            if (parseInt(Slider.css("left")) > ($(".QapTcha .bgSlider").width() - 80))
                                return false;
                            else
                                return true;
                        }
                    },
                    containment: bgSlider,
                    axis: 'x',
                    stop: function (event, ui) {
                        console.log("usaooo");
                        if (ui.position.left > ($(".QapTcha .bgSlider").width() - 82))
                        {
                            Slider.addClass('active-captcha');

                            $.post(opts.servlet, {
                                action: 'qaptcha',
                                qaptcha_key: inputQapTcha.attr('name')
                            },
                                    function (data) {
                                        if (typeof data.qaptcha_key !== 'undefined') {
                                            Slider.draggable('disable').css('cursor', 'default');
                                            inputQapTcha.val('');
                                            console.log("hcgfd");
                                            TxtStatus.text(opts.txtUnlock).addClass('dropSuccess').removeClass('dropError');
//                                            form.find('button[type="submit"]').removeClass('disabled');
                                            console.log("usaoooo");
                                            $('#recoveryBtn').removeClass('disabled');
//								form.find('input[type=\'submit\']').removeAttr('disabled');
                                            $('#sendComment').removeAttr('disabled');
                                            $('#recoveryBtn').removeAttr('disabled');
                                            if (opts.autoSubmit)
                                                form.find('input[type="submit"]').trigger('click');
                                            $('#antiRobotAnswer').val(data.qaptcha_key);
                                            $this.parents('form').first().append('<input type="hidden" name="antiRobotAnswer" value="' + data.qaptcha_key + '" />');
                                        }
                                    }, 'json');
                        } else {
                            Slider.removeClass('active-captcha');
                        }
                    }
                });

                function generatePass(nb) {
                    var chars = 'azertyupqsdfghjkmwxcvbn23456789AZERTYUPQSDFGHJKMWXCVBN_-#@';
                    var pass = '';
                    for (i = 0; i < nb; i++) {
                        var wpos = Math.round(Math.random() * chars.length);
                        pass += chars.substring(wpos, wpos + 1);
                    }
                    return pass;
                }

            });
    }
};
jQuery.fn.QapTcha = jQuery.QapTcha.build;